import script from "./FundCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./FundCarousel.vue?vue&type=script&setup=true&lang=js"

import "./FundCarousel.vue?vue&type=style&index=0&id=4011453a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4011453a"]])

export default __exports__